import React from "react";
import BulasikMakinaParlaticisi from "../Components/product/BulasikMakinaParlaticisi";
import PageHeader from "../Components/common/PageHeader";
import { t } from "i18next";
import BulasikMakinaParlaticisiPro from "../Components/product/BulasikMakinaParlaticisiPro";
import ProductSEO from "../Components/common/ProductSEO";

function BulasikMakinaParlaticisiProPage() {
    return (
        <>
            <ProductSEO
                name="Bulaşık Makina Parlatıcısı Pro (Durulama)"
                description="Profesyonel parlatıcı ile mükemmel durulama ve parlaklık."
                slug="bulasikmakinaparlaticisipro"
                imagePath="assets/images/20-kg/14.webp"
            />
            <PageHeader title={t("BULAŞIK MAKİNA PARLATICISI PRO (DURULAMA)")} />
            <BulasikMakinaParlaticisiPro />
        </>
    );
}

export default BulasikMakinaParlaticisiProPage;